import * as utils from "@sharedJS/utils";

import * as myAccountOffCanvasHeadline from "@sharedJS/myAccountOffCanvasHeadline";
import * as popUpOverlay from "@sharedJS/popUpOverlay";
import * as storage from "@sharedJS/storage";

import OcmMessenger from "ocm_mercurius_messenger";
import { messengerPublicationTypes } from "@ocm/services/services.constants.js";

//Dom
let $offCanvasWrapper;
let $offCanvasLeft;
let $offCanvasLeftBtn;

let $offCanvasRight;

let $myAccountOffCanvasButton;
let $openCustomerCard;

let $offCanvasClose;

let $myAccountOffCanvasContent;

let $openSearchButton;

const openOffcanvasCookieName = "openOffcanvas";

function init() {
	$offCanvasLeft = $(".js-offcanvas-left");
	$offCanvasRight = $(".js-offcanvas-right");

	if (!$offCanvasLeft.length && !$offCanvasRight.length) {
		return;
	}

	OcmMessenger.subscribe(messengerPublicationTypes.ROUTE_CHANGE, _resetMenu);

	//Dom
	$openCustomerCard = $(".js-open-customer-card");

	$offCanvasWrapper = $(".js-offcanvas-wrapper");

	$offCanvasClose = $(".js-offcanvas-close");

	$offCanvasLeftBtn = $(".js-left-trigger");
	$myAccountOffCanvasButton = $(".js-my-account-offcanvas-button");

	$myAccountOffCanvasContent = $("#my-account-canvas");
	$myAccountOffCanvasContent.hide().removeClass("u-hide");

	$openSearchButton = document.querySelector(".js-open-search");

	//Dependencies
	_bindOpenLeftOffCanvas(); // left off-canvas = Navigation
	_bindNavLinks(); // Navigation

	_bindOpenMyAccountOffCanvas(); // right off-canvas = MyAccount
	_listenOnCustomerCard(); // MyAccount

	_closeOffCanvas();
	_offCanvasResize();

	const initCanvas = storage.getCookie(openOffcanvasCookieName);
	if (initCanvas === "left") {
		_openLeftOffCanvas();
	}
	storage.deleteCookie(openOffcanvasCookieName);

	addEventListener("popstate", _closeCanvas);

	if ($openSearchButton) _bindOpenSearch(); // Search
}

// Navigation
function _bindNavLinks() {
	const transitionDuration = 400;
	$offCanvasLeft[0]?.style.setProperty("--navTransitionDuration", `${transitionDuration}ms`);

	const $burgerSlides = $offCanvasLeft.find(".js-offcanvas-nav");
	const $burgerLinks = $burgerSlides.find("a[data-nav]"); // Links innerhalb des BurgerMenüs

	$burgerSlides.find("a[href]:not([data-nav], [data-department])").click(() => _closeCanvas());

	// SPA-Handler deaktivieren für Links innerhalb des Burgers // besser gar kein onClick???
	// TODO: TUB-12459 //
	$burgerLinks.removeAttr("onclick");

	// Burger-Navigation
	$burgerLinks.on("click", function (e) {
		const $link = $(this);
		const $currentSlide = $link.closest($burgerSlides);
		const targetId = $link.data("nav");
		const $targetSlide = $burgerSlides.filter(`#${targetId}`);
		const isNext = !!$currentSlide.nextAll(`#${targetId}`).length;

		if (!$targetSlide.length) return;
		e.preventDefault();

		if (isNext) $targetSlide.addClass("js-nav-next");
		$targetSlide.show();
		_scrollSlideToTop($targetSlide);

		requestAnimationFrame(() => {
			$currentSlide.removeClass("js-nav-active").addClass(isNext ? "" : "js-nav-next");
			$targetSlide.addClass("js-nav-active").removeClass("js-nav-next");

			setTimeout(() => {
				$currentSlide.hide().removeClass("js-nav-next");
			}, transitionDuration);
		});
	});

	$burgerSlides.find("a[data-department]").on("click", () => {
		storage.setCookie(openOffcanvasCookieName, "left");
	});
}

function _resetMenu() {
	_closeCanvas();
	_showFirstSlide(); // Navigation
}

// Navigation
function _showFirstSlide() {
	const $burgerSlides = $offCanvasLeft.find(".js-offcanvas-nav");
	$burgerSlides.removeClass("js-nav-active").hide();
	$burgerSlides.first().addClass("js-nav-active").show();
	_scrollSlideToTop($burgerSlides.first());
}

function _scrollSlideToTop($slide) {
	const burgerNavigationMainClass = ".js-offcanvas-nav-main"; // Navigation Scrollable Part
	$slide.find(burgerNavigationMainClass).scrollTop(0);
}

// Navigation
function _bindOpenLeftOffCanvas() {
	$offCanvasLeftBtn.on("click", () => {
		_openLeftOffCanvas();
	});
}

// MyAccount
function _bindOpenMyAccountOffCanvas() {
	$myAccountOffCanvasButton.on("click", _openMyAccountOffCanvas);
}

// Navigation
function _openLeftOffCanvas() {
	_openCanvas("is-left-offcanvas", $(".js-left-scrollable"), $(".js-left-scrollable-inner"));
	utils.removeIOSRubberEffect(".js-left-scrollable");
}

// MyAccount
function _openMyAccountOffCanvas() {
	$myAccountOffCanvasContent.show();
	if ($(".is-right-offcanvas").length === 0) {
		myAccountOffCanvasHeadline.fillMyAccountOffCanvasHeadline();
	}
	_openCanvas("is-right-offcanvas", $(".js-offcanvas-right"), $(".js-right-scrollable-inner"));
	utils.removeIOSRubberEffect(".js-right-scrollable");
}

function _openCanvas(canvas, $scrollableBox, $scrollableInner) {
	history.pushState({ isOffcanvasOpen: true }, "", "");
	$offCanvasWrapper.addClass(canvas);
	//
	const scrollableBoxHeight = $scrollableBox.innerHeight();
	const scrollableInnerHeight = $scrollableInner.height();
	if (scrollableBoxHeight >= scrollableInnerHeight) {
		$scrollableInner.css({ minHeight: scrollableBoxHeight });
	}
	utils.disableScrolling(true);
}

function _closeOffCanvas() {
	$offCanvasClose.on("click", () => {
		_closeCanvas();
	});
}

function _listenOnCustomerCard() {
	$openCustomerCard.on("click", () => {
		popUpOverlay.openCustomerCard();
	});
}

function _closeCanvas() {
	$offCanvasWrapper.removeClass("is-left-offcanvas");
	$offCanvasWrapper.removeClass("is-right-offcanvas");
	$offCanvasWrapper.one("transitionend", _showFirstSlide);

	utils.disableScrolling(false);

	if (history.state?.isOffcanvasOpen) history.back();
}

function _offCanvasResize() {
	addEventListener("resize", () => {
		if (
			!document.querySelector(".js-offcanvas-wrapper.is-left-offcanvas") &&
			!document.querySelector(".js-offcanvas-wrapper.is-right-offcanvas")
		)
			return;
		if (matchMedia("(min-width: 64em)").matches) _closeCanvas();
	});
}

function myAccountOffCanvasButtonToggle() {
	_closeCanvas();
}

// Search
function _bindOpenSearch() {
	$openSearchButton.addEventListener("click", () => {
		OcmMessenger.publish(messengerPublicationTypes.OPEN_SEARCH);
	});
}

export { init, myAccountOffCanvasButtonToggle };
